<div class="trezo-card bg-white dark:bg-[#0c1427] p-[20px] md:p-[25px] rounded-md">
    <div class="trezo-card-content">
        <span class="block">
            Total Orders
        </span>
        <h5 class="!text-[20px] mt-[3px] !mb-0">
            25k+
        </h5>
        <div class="flex items-center justify-center mx-auto text-purple-500 bg-purple-100 dark:bg-[#15203c] w-[77px] h-[77px] my-[15px] rounded-full">
            <i class="material-symbols-outlined !text-[32px]">
                collections_bookmark
            </i>
        </div>
        <div class="flex items-center justify-between text-sm">
            <span class="block">
                This Month
            </span>
            <span class="leading-none text-danger-500">
                <i class="material-symbols-outlined !text-[20px]">
                    trending_down
                </i>
            </span>
        </div>
    </div>
</div>